import { Badge, Flex, InfoIconWithTooltip } from "@shared/primitive-components"
import { rebatesStyles as styles } from "../styles"

export const LOZENGE_DTI = {
  CONTENT: `content`,
  ICON: `icon`,
}

type Props = {
  title: string
  tooltipContent?: JSX.Element
}

export const Lozenge = ({ title, tooltipContent }: Props) => (
  <Badge variant="brand" size="lg" css={styles.marginBottom(4)}>
    <Flex data-testid={LOZENGE_DTI.CONTENT} alignItems="center" justifyContent="space-between">
      {title}
      {tooltipContent && <InfoIconWithTooltip contentTestId={LOZENGE_DTI.ICON} content={tooltipContent} />}
    </Flex>
  </Badge>
)

Lozenge.defaultProps = {
  tooltipContent: undefined,
}
